var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { DoricPlugin } from "../DoricPlugin";
export class NetworkPlugin extends DoricPlugin {
    request(args) {
        return __awaiter(this, void 0, void 0, function* () {
            let result;
            let error;
            if (args.method.toLowerCase() === "get") {
                try {
                    result = yield axios.get(args.url, {
                        headers: args.headers ? args.headers : {},
                        timeout: args.timeout
                    });
                }
                catch (exception) {
                    error = exception;
                }
            }
            else if (args.method.toLowerCase() === "post") {
                try {
                    result = yield axios.post(args.url, args.data, {
                        headers: args.headers ? args.headers : {},
                        timeout: args.timeout
                    });
                }
                catch (exception) {
                    error = exception;
                }
            }
            else if (args.method.toLowerCase() === "put") {
                try {
                    result = yield axios.put(args.url, args.data, {
                        headers: args.headers ? args.headers : {},
                        timeout: args.timeout
                    });
                }
                catch (exception) {
                    error = exception;
                }
            }
            else if (args.method.toLowerCase() === "delete") {
                try {
                    result = yield axios.delete(args.url, {
                        headers: args.headers ? args.headers : {},
                        timeout: args.timeout
                    });
                }
                catch (exception) {
                    error = exception;
                }
            }
            result.data = JSON.stringify(result.data);
            if (result) {
                return Promise.resolve(result);
            }
            if (error) {
                return Promise.reject(error);
            }
        });
    }
}
//# sourceMappingURL=NetworkPlugin.js.map